import { LayoutBand, Separator } from '@fs/zion-ui'
import React from 'react'
import ContributionsHeaderSkeleton from './ContributionsHeader/ContributionsHeaderSkeleton'
import ContributionsActionBarSkeleton from './ContributionsActionBar/ContributionsActionBarSkeleton'
import ContributionsViewSkeleton from './ContributionsView/ContributionsViewSkeleton'

export default function ContributionsPageSkeleton(): JSX.Element {
  return (
    <>
      <ContributionsHeaderSkeleton />

      <LayoutBand maxWidth="xxl">
        <Separator size="xxs" />
        <ContributionsActionBarSkeleton />
        <ContributionsViewSkeleton />
      </LayoutBand>
      <Separator />
    </>
  )
}
